module.exports = __webpack_public_path__ + "img/appAsset-brand--khipu.8fef5910.svg";